<template>
    <!-- 对话框 -->
    <el-dialog :visible.sync="show" :before-close="closeDialog" center width="500px"
               :close-on-click-modal="false">
        <el-form ref="form" :model="submit_data" class="box">
            <div>请设置隐私通话预警分钟数</div>
            <el-input v-model="submit_data.alert_num" style="width: 200px"></el-input>

        </el-form>
        <!-- 对话框底部按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">返回</el-button>
        </span>
    </el-dialog>
</template>

<script>
    var _this

    export default {
        props: {
            'isShow': Boolean,
            'data': '',
            'editcode': ''
        },
        watch: {

            isShow(newData, oldData) {
                _this.show = true;
                _this.submit_data.alert_num = _this.data;
            },






        },
        data() {
            return {
                submit_data: {
                    alert_num:''
                },


                show: false,





                submit_rules: {


                    alert_num: {
                        placeholder: '请填写分钟数',
                        rules: {
                            required: false,
                            message: '填写备注',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },

                }


            };
        },
        created() {
            _this = this;
        },

        methods: {


            closeDialog() {

                _this.show = false;
                _this.submit_data = {
                    alert_num:''
                };

            },
            // 提交
            onSubmit() {


                _this.$post(
                    "/privateno/changeAlertNum",
                    _this.submit_data,
                    _this.submit_rules
                )
                    .then(res => {
                        console.log(res)
                        this.$message.success(res.msg);
                        _this.$emit('onSubmit')



                            _this.closeDialog();




                    })
            },



        }
    };
</script>

<style scoped>
    #container_edit {
        height: 90%;
        width: 35%;
        float: left;
    }

    .form-box {
        width: 65%;
        padding: 20px;
        box-sizing: border-box;
        float: left;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .box{
        text-align: center;
    }
    .box div{
        font-size: 16px;
        margin-bottom: 10px;
    }
</style>
